import ContractTypeAhead from './ContractTypeAhead';

export default ContractTypeAhead;
